<script>
export default {
  props: ['header', 'item', 'items', 'schema'],
  render: function (/*createElement*/) {
    const slot = this.header.slot
    return slot({item: this.item, items: this.items, schema: this.schema})
  }
}
</script>
